import { Separator } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './select.scss';

type Props = ComponentPropsWithoutRef<typeof Separator>;
export const SelectSeparator = ({ className, ...props }: Props) => {
    return (
        <Separator data-testid="select-separator" className={cn('select__separator', className)} {...props} />
    );
};
